import cookie from '../../../util/cookie';
import platform from 'platform';
export * from './commonSelectors';

export const SET_SALES_SESSION_ID = 'hg/common/SET_SALES_SESSION_ID';
export const SET_OFFER_ID = 'hg/common/SET_OFFER_ID';
export const SET_ERROR = 'hg/common/SET_ERROR';
export const SET_CONTACT_US_ERROR = 'hg/common/SET_CONTACT_US_ERROR';
export const SET_PAGE_ERRORS = 'hg/common/SET_PAGE_ERRORS';
export const SET_DEV = 'hg/common/SET_DEV';
export const TOGGLE_LOADING = 'hg/common/TOGGLE_LOADING';
export const TOGGLE_SPINNER = 'hg/common/TOGGLE_SPINNER';
export const UPDATE_SPINNER = 'hg/common/UPDATE_SPINNER';
export const TOGGLE_EXPERIMENT = 'hg/common/TOGGLE_EXPERIMENT';
export const SET_FLOW = 'hg/common/SET_FLOW';
export const SET_FLOW_TYPE = 'hg/common/SET_FLOW_TYPE';
export const SET_CONSUMER_TYPE = 'hg/common/SET_CONSUMER_TYPE';

// TODO: clear initial values
const DEFAULT_USER_ID = '';
const DEFAULT_OFFER_ID = '210105';

let spinnerTimeout;

export const initialState = {
  salesSessionId : '',
  userId : cookie.getUserId() || DEFAULT_USER_ID,
  offerId: DEFAULT_OFFER_ID,
  consumerType: '',
  flow: '',
  flowType: '',
  loading: false,
  experiment: false,
  spinner: {
    show: false,
    hideContent: true,
    priority: 0
  },
  error: null,
  pageErrors: [],
  dev: false,
  platform: {
    os: {
      family: platform.os.family
    }
  }
};

export const common = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_SALES_SESSION_ID:
      return {
        ...state,
        salesSessionId: action.salesSessionId
      };

    case SET_OFFER_ID:
      return {
        ...state,
        offerId: action.offerId
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.error
      };

    case SET_CONTACT_US_ERROR:
      return {
        ...state,
        contactUsErrorCode: action.error
      };

    case SET_PAGE_ERRORS:
      return {
        ...state,
        pageErrors: action.pageErrors
      };

    case SET_DEV:
      return {
        ...state,
        dev: action.dev
      };

    case TOGGLE_LOADING:
      return {
        ...state,
        loading: action.loading
      };

    case TOGGLE_SPINNER:
      return {
        ...state,
        spinner: action.spinner
      };

    case UPDATE_SPINNER:
      return {
        ...state,
        spinner: {
          ...state.spinner,
          ...action.payload
        }
      };

    case TOGGLE_EXPERIMENT:
      return {
        ...state,
        experiment: action.experiment
      };

    case SET_FLOW:
      return {
        ...state,
        flow: action.flow
      };

    case SET_FLOW_TYPE:
      return {
        ...state,
        flowType: action.flowType
      };

    case SET_CONSUMER_TYPE:
      return {
        ...state,
        consumerType: action.consumerType
      };

    default:
      return state;
  }
};

export const setSalesSessionId = salesSessionId => {
  return {
    type: SET_SALES_SESSION_ID,
    salesSessionId: salesSessionId
  };
};

export const setOfferId = offerId => {
  // cookie.save('offerId', offerId, { path: '/' });
  return {
    type: SET_OFFER_ID,
    offerId: offerId
  };
};

export const setError = error => {
  return {
    type: SET_ERROR,
    error
  };
};

export const setContactUsError = error => {
  return {
    type: SET_CONTACT_US_ERROR,
    error
  };
};

export const setPageErrors = pageErrors => {
  return {
    type: SET_PAGE_ERRORS,
    pageErrors
  };
};

export const setDev = (isDev) => {
  return {
    type: SET_DEV,
    dev: isDev
  };
};

export const toggleLoading = loading => {
  return {
    type: TOGGLE_LOADING,
    loading
  };
};

export const showGlobalSpinner = ({
  delayed: delayed = false,
  hideContent: hideContent = true,
  delayAmount: delayAmount = 500,
  priority: priority = 0,
  message: message = '',
  initiator: initiator = ''
} = {}) => {
  // clearTimeout(spinnerTimeout);dispatch(hideGlobalSpinner());
  // const delay = delayed ? delayAmount : 0;

  return dispatch => {
    dispatch(hideGlobalSpinner());
    const action = {
      type: TOGGLE_SPINNER,
      spinner: {
        show: true,
        hideContent,
        priority,
        message,
        // for debugging
        initiator
      }
    };

    if (delayed) {
      spinnerTimeout = setTimeout(() => {
        dispatch(action);
      }, delayAmount);
    } else {
      dispatch(action);
    }
  };
};

export const hideGlobalSpinner = (initiator) => {
  clearTimeout(spinnerTimeout);
  return {
    type: TOGGLE_SPINNER,
    spinner: {
      show: false,
      // for debugging
      initiator
    }
  };
};

export const updateGlobalSpinner = payload => {
  return {
    type: UPDATE_SPINNER,
    payload
  };
};

export const toggleExperiment = experiment => {
  return {
    type: TOGGLE_EXPERIMENT,
    experiment
  };
};

export const setFlow = flow => {
  return {
    type: SET_FLOW,
    flow
  };
};

export const setFlowType = flowType => {
  return {
    type: SET_FLOW_TYPE,
    flowType
  };
};

export const setConsumerType = consumerType => {
  return {
    type: SET_CONSUMER_TYPE,
    consumerType
  };
};

export default common;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/common/common.js
 **/